import { Component, Input, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SendDataService } from '../../../../../shared/services/send-data.service';
import { Button, RoutePath } from '../../../../../shared/model/enum';
import { PartsListService } from '../../pages/parts-list/parts-list.service';
import { StorageService } from '../../../../../shared/services/storage.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-add-edit-consignment',
  templateUrl: './add-edit-consignment.component.html',
  styleUrls: ['./add-edit-consignment.component.scss']
})
export class AddEditConsignmentComponent implements OnInit {
  enumButtonName = Button;
  title
  @Input() formModel: any = {}
  @Input() data: any = {}

  visibility: boolean = false

  constructor(public activeModal: NgbActiveModal, public toaster: ToastrService,
    public renderer: Renderer2,
    public sendDataService: SendDataService,
    public partsListService: PartsListService,
    public storageService: StorageService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.data = this.data ?? {}
    this.data.consignmentDetail = true;
    this.formModel = {
      ...this.formModel,
      mpnId : this.data?.selectedData?.id,
      mfrId : this.data?.selectedData?.mfrId
    }
  }
  checkValidation(): boolean {
    let value = this.formModel?.companyId && this.formModel?.mpnId && this.formModel?.mfrId;
    return value ? false : true
  }
  onNextClick(label) {
    if (this.checkValidation()) {
      // this.toaster.error('Please fill Company,MPN,MFR.')
      this.toaster.error('Please fill required fields.')
      return
    }
    this.partsListService.btnNext = true
    this.visibility = label == 'Next' ? true : false
  }

  onAddIConsignmentClick() {
    let lineModel = this.formModel?.inventoryLineModel ?? []
    lineModel.forEach(row => {
      if (Array.isArray(row.lineImagesModel)) {
        row.lineImagesModel.forEach(image => {
          if (image.hasOwnProperty('imageUploadList')) {
            delete image.imageUploadList;
          }
        });
      }
      if (Array.isArray(row.splitLineModel)) {
        row.splitLineModel.forEach(splitRow => {
          if (Array.isArray(splitRow.splitLineImagesModel)) {
            splitRow.splitLineImagesModel.forEach(image => {
              if (image.hasOwnProperty('imageUploadList')) {
                delete image.imageUploadList;
              }
            });
          }
        });
      }
    });
    this.formModel.contactEndDate = this.data?.contactEndDate
    lineModel = lineModel?.filter(item => item.qty);
    this.formModel.inventoryLineModel = lineModel?.map(item => ({
      ...item,
      splitLineModel: item?.splitLineModel?.filter(subItem => subItem.qty)
    }));
    this.partsListService.addPartConsignment(this.formModel).subscribe((res) => {
      if (res?.isSuccess) {
        this.toaster.success(res.message);
        this.activeModal.close({ res: res?.response, confirm: true })
        const urlSegment = this.router?.url?.split('/').pop();
        if (urlSegment == res?.response?.mpnId) {
          this.partsListService.id = res?.response?.mpnId;
          this.partsListService.inventoryListUpdated.next(true);
          this.partsListService.setCount(0)
        } else if (this.router.url == RoutePath.PARTLIST_ROUTEPATH && this.partsListService.id) {
          this.partsListService.inventoryListUpdated.next(true);
          this.partsListService.setCount(0)
        }
      }
    })
  }
  cancel() {
    this.activeModal.close({ confirm: false })
  }
  clearValue() {
    this.partsListService.btnNext = false
  }

}
